var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "b-container",
    { attrs: { fluid: "" } },
    [
      _c("admin-preloader", { attrs: { show: _vm.loading } }),
      _vm._v(" "),
      _c("admin-breadcrumb", {
        attrs: {
          items: [{ text: "Taxonomies", path: { name: "admin-taxonomies" } }],
          name: "Categories",
          "no-title": "",
        },
      }),
      _vm._v(" "),
      _c(
        "b-row",
        [
          _c(
            "b-col",
            { attrs: { cols: "12" } },
            [
              _c(
                "admin-panel",
                {
                  attrs: { title: "Categories" },
                  scopedSlots: _vm._u([
                    {
                      key: "header-right",
                      fn: function () {
                        return [
                          _c("b-form-select", {
                            staticClass: "w-auto mr-2",
                            attrs: { options: _vm.categoryTypeOptions },
                            model: {
                              value: _vm.category_type_filter,
                              callback: function ($$v) {
                                _vm.category_type_filter = $$v
                              },
                              expression: "category_type_filter",
                            },
                          }),
                          _vm._v(" "),
                          _c(
                            "no-permission-wrapper",
                            { attrs: { show: !_vm.canCreateTaxonomies } },
                            [
                              _c(
                                "b-btn",
                                {
                                  attrs: {
                                    variant: "success",
                                    disabled: !_vm.canCreateTaxonomies,
                                  },
                                  on: { click: _vm.openNewModal },
                                },
                                [_vm._v("Add new Category")]
                              ),
                            ],
                            1
                          ),
                        ]
                      },
                      proxy: true,
                    },
                  ]),
                },
                [
                  _vm._v(" "),
                  _c("b-table", {
                    attrs: {
                      fields: _vm.table_fields,
                      items: _vm.categories,
                      "table-class": "text-nowrap",
                      responsive: "",
                    },
                    scopedSlots: _vm._u([
                      {
                        key: "cell(name)",
                        fn: function (data) {
                          return [
                            _c("h4", { staticClass: "mb-0" }, [
                              _vm._v(_vm._s(data.item.name)),
                            ]),
                          ]
                        },
                      },
                      {
                        key: "cell(categoryType)",
                        fn: function (data) {
                          return [
                            _c("span", [
                              _vm._v(
                                _vm._s(
                                  _vm.getCategoryTypeName(
                                    data.item.category_type_id
                                  )
                                )
                              ),
                            ]),
                          ]
                        },
                      },
                      {
                        key: "cell(actions)",
                        fn: function (data) {
                          return [
                            _c(
                              "no-permission-wrapper",
                              { attrs: { show: !_vm.canUpdateTaxonomies } },
                              [
                                _c(
                                  "b-btn",
                                  {
                                    attrs: {
                                      variant: "primary",
                                      disabled: !_vm.canUpdateTaxonomies,
                                    },
                                    on: {
                                      click: function ($event) {
                                        $event.preventDefault()
                                        return _vm.openEditModal(data.item)
                                      },
                                    },
                                  },
                                  [_vm._v("Edit")]
                                ),
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "no-permission-wrapper",
                              { attrs: { show: !_vm.canDeleteTaxonomies } },
                              [
                                _c(
                                  "b-btn",
                                  {
                                    attrs: {
                                      variant: "danger",
                                      disabled: !_vm.canDeleteTaxonomies,
                                    },
                                    on: {
                                      click: function ($event) {
                                        $event.preventDefault()
                                        return _vm.confirmDelete(data.item)
                                      },
                                    },
                                  },
                                  [_vm._v("Delete")]
                                ),
                              ],
                              1
                            ),
                          ]
                        },
                      },
                    ]),
                  }),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _vm.edit_category
        ? _c("admin-category-edit-modal", {
            attrs: { category: _vm.edit_category, visible: "" },
            on: {
              cancel: function ($event) {
                _vm.edit_category = null
              },
              success: _vm.onCategoryEdited,
            },
          })
        : _vm._e(),
      _vm._v(" "),
      _c("admin-category-add-modal", {
        ref: "newModal",
        on: { success: _vm.onCategoryAdded },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }